import { GET } from "@/api/request";
let reqUrl = "/api/h5"; //线上
// let reqUrl = ""; //本地

// 获取 顶banner和轮播banner 的接口
export const getBanner = (params) => {
  return GET(reqUrl + "/bannImg/list", params);
};

// 获取首页新闻列表
export const getHomeList = (params) => {
  return GET(reqUrl + "/article/index", params);
};

// 获取新闻列表
export const getArticleList = (params) => {
  return GET(reqUrl + "/article/page", params);
};

// 获取机构顶部广告
export const getBannerGuangGao = (params) => {
  return GET(reqUrl + "/article/columuBanner", params);
};

// 获取新闻详情
export const getArticleInfo = (params) => {
  return GET(reqUrl + "/article/info", params);
};

// 获取财报可视化列表
export const getFinancialReport = (params) => {
  return GET(reqUrl + "/financialReport/page", params);
};

// 获取财报可视化列表
export const getFinancialReportInfo = (params) => {
  return GET(reqUrl + "/financialReport/info", params);
};

// 模糊搜索
export const getSearchGuess = (params) => {
  return GET(reqUrl + "/es/guess", params);
};

// 全局搜索
export const getSearch = (params) => {
  return GET(reqUrl + "/es/search", params);
};

// 信披一级
export const get3060Parent = (params) => {
  return GET(reqUrl + "/info3060/list", params);
};

// 信披二级
export const get3060Page = (params) => {
  return GET(reqUrl + "/info3060/page", params);
};

// 获取智能财讯列表
export const getFncList = (params) => {
  return GET(reqUrl + "/shuwen/page", params);
};

// 获取智能财讯详情
export const getFncInfo = (params) => {
  return GET(reqUrl + "/shuwen/info", params);
};

// 获取公司列表
export const getIpoList = (params) => {
  return GET(reqUrl + "/ipo/page", params);
};

// 获取公司详情
export const getIpoInfo = (params) => {
  return GET(reqUrl + "/ipo/info/all", params);
};

export const taurusList = (params) => {
  return GET(reqUrl + "/taurus/list");
};

export const taurusType = (params) => {
  return GET(reqUrl + "/taurus/type", params);
};

export const taurusPage = (params) => {
  return GET(reqUrl + "/taurus/page", params);
};

// 信披模糊搜索
export const getInfo3060Guess = (params) => {
  return GET(reqUrl + "/info3060/companyCode", params);
};

// 信披搜索
export const getInfo3060Search = (params) => {
  return GET(reqUrl + "/info3060/company", params);
};

// 获取视频分类
export const getVideoCategory = (params) => {
  return GET(reqUrl + "/video/Category", params);
};

// 获取视频分类列表
export const getVideoPage = (params) => {
  return GET(reqUrl + "/video/page", params);
};

// 获取视频首页列表
export const getVideoHomeList = (params) => {
  return GET(reqUrl + "/video/list", params);
};

//微信分享
export const findWxShareConfigInfo = (params) => {
  return GET(reqUrl + "/wx/getShareParam", params);
};

//获取系统设置
export const getConfig = (params) => {
  return GET(reqUrl + "/config/get", params);
};

export const sendLog = (params) => {
  return GET(reqUrl + "/log/info", params);
};
